export default function RenderMatrixSummary({ question, t, formData }) {
  const raw = formData?.[question.id] ?? {};
  const yes = t("sgrq.scales.yesNo.true") || "True";
  const no = t("sgrq.scales.yesNo.false") || "False";
  const na = t("common.na") || "N/A";

  return (
    <ul className="mt-1 rounded-lg border border-greyscale-1 divide-y divide-greyscale-1 w-full">
      {question.rows.map((r) => {
        const v = raw?.[r.id];
        const val = v === true ? yes : v === false ? no : na;
        return (
          <li key={r.id} className="flex items-start justify-between gap-4 p-3">
            <span className="text-gray-700">
              {t(r.labelKey ?? r.label ?? r.id)}
            </span>
            <span className="font-medium">{val}</span>
          </li>
        );
      })}
    </ul>
  );
}
